import { AxiosPromise, AxiosStatic } from "axios";
import {
  CreateZakatAssetRequest,
  CreateZakatLiabilityRequest,
  CreateZakatPaymentRequest,
  CreateZakatPaymentResponse,
  UpdateZakatAssetRequest,
  UpdateZakatLiabilityRequest,
  UpdateZakatRequest,
  UpdateDraftZakatRequest,
  Zakat,
  ZakatResponseDto,
  ZakatAsset,
  ZakatBreakdownResponse,
  ZakatFormulaResponse,
  ZakatLiability,
  ZakatPortfolio,
} from "../types/Zakat";

export const getZakat =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (): AxiosPromise<ZakatResponseDto> =>
    await appAxios.get(`${serverURL}/zakat`, {
      withCredentials: true,
    });

export const getAllZakats =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (): AxiosPromise<Zakat[]> =>
    await appAxios.get(`${serverURL}/zakat/all`, {
      withCredentials: true,
    });

export const getNisab =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (): AxiosPromise<number> =>
    await appAxios.get(`${serverURL}/zakat/nisab`, {
      withCredentials: true,
    });

export const updateZakat =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (data: UpdateZakatRequest): AxiosPromise<Zakat> =>
    await appAxios.put(`${serverURL}/zakat`, data, {
      withCredentials: true,
    });

export const createZakatAsset =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (data: CreateZakatAssetRequest): AxiosPromise<ZakatAsset> =>
    await appAxios.post(`${serverURL}/zakat/assets`, data, {
      withCredentials: true,
    });

export const updateZakatAsset =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    assetId: string,
    data: UpdateZakatAssetRequest
  ): AxiosPromise<ZakatAsset> =>
    await appAxios.put(`${serverURL}/zakat/assets/${assetId}`, data, {
      withCredentials: true,
    });

export const deleteZakatAsset =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (assetId: string): AxiosPromise<void> =>
    await appAxios.delete(`${serverURL}/zakat/assets/${assetId}`, {
      withCredentials: true,
    });

export const createZakatLiability =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (data: CreateZakatLiabilityRequest): AxiosPromise<ZakatLiability> =>
    await appAxios.post(`${serverURL}/zakat/liabilities`, data, {
      withCredentials: true,
    });

export const updateZakatLiability =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    liabilityId: string,
    data: UpdateZakatLiabilityRequest
  ): AxiosPromise<ZakatLiability> =>
    await appAxios.put(`${serverURL}/zakat/liabilities/${liabilityId}`, data, {
      withCredentials: true,
    });

export const deleteZakatLiability =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (liabilityId: string): AxiosPromise<void> =>
    await appAxios.delete(`${serverURL}/zakat/liabilities/${liabilityId}`, {
      withCredentials: true,
    });

export const getZakatPortfolio =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (): AxiosPromise<ZakatPortfolio[]> =>
    await appAxios.get(`${serverURL}/zakat/portfolio`, {
      withCredentials: true,
    });

export const getZakatBreakdown =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (zakatId: string): AxiosPromise<ZakatBreakdownResponse> =>
    await appAxios.get(`${serverURL}/zakat/${zakatId}/breakdown`, {
      withCredentials: true,
    });

export const createZakatPayment =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    data: CreateZakatPaymentRequest
  ): AxiosPromise<CreateZakatPaymentResponse> =>
    await appAxios.post(`${serverURL}/payments/zakat`, data, {
      withCredentials: true,
    });

export const getZakatFormula =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (): AxiosPromise<ZakatFormulaResponse> =>
    await appAxios.get(`${serverURL}/zakat/formula`, {
      withCredentials: true,
    });

export const getZakatById =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (zakatId: string): AxiosPromise<Zakat> =>
    await appAxios.get(`${serverURL}/zakat/${zakatId}`, {
      withCredentials: true,
    });

export const cloneLatestZakat =
  (serverURL: string, appAxios: AxiosStatic) => async (): AxiosPromise<Zakat> =>
    await appAxios.post(
      `${serverURL}/zakat/clone-latest`,
      {},
      {
        withCredentials: true,
      }
    );

export const getDraftZakat =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (): AxiosPromise<Zakat | null> =>
    await appAxios.get(`${serverURL}/zakat-v2`, {
      withCredentials: true,
    });

export const createDraftZakat =
  (serverURL: string, appAxios: AxiosStatic) => async (): AxiosPromise<Zakat> =>
    await appAxios.post(
      `${serverURL}/zakat-v2`,
      {},
      {
        withCredentials: true,
      }
    );

export const updateDraftZakat =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (data: UpdateDraftZakatRequest): AxiosPromise<Zakat> =>
    await appAxios.put(`${serverURL}/zakat-v2`, data, {
      withCredentials: true,
    });
